module.exports = __webpack_public_path__ + "static/media/bg-1920.999e5ac3.jpg";